import { apiFetchJson } from './apiClient';
import type { MarketProfileState } from '../components/Community/marketProfile/marketProfileStore';

export type MembershipFilter = 'all' | 'approved' | 'not_approved';
export type QuestionnaireFilter = 'all' | 'yes' | 'no' | 'pending';

export type CommunityMemberAdmin = {
  id: string;
  userId: string | null;
  applicationId: number | null;
  email: string;
  firstName: string | null;
  lastName: string | null;
  pseudonym: string | null;
  company: string | null;
  sector: string | null;
  title: string | null;
  phone: string | null;
  membershipStatus: 'pending' | 'approved' | 'rejected' | 'none';
  applicationSubmittedAt: string | null;
  membershipApprovedAt: string | null;
  positionStatus: string;
  positionReviewSubmittedAt: string | null;
  positionApprovedAt: string | null;
  gradingStatus: string;
  gradingReviewSubmittedAt: string | null;
  gradingApprovedAt: string | null;
  marketProfileConfirmedAt: string | null;
  profileState?: MarketProfileState;
};

export type CommunityMembersResponse = {
  data: CommunityMemberAdmin[];
  total: number;
  reviewWindowMs: number;
};

export async function fetchCommunityMembers(params: {
  membership?: MembershipFilter;
  position?: QuestionnaireFilter;
  grading?: QuestionnaireFilter;
  search?: string;
}): Promise<CommunityMembersResponse> {
  const qs = new URLSearchParams();
  if (params.membership) qs.set('membership', params.membership);
  if (params.position) qs.set('position', params.position);
  if (params.grading) qs.set('grading', params.grading);
  if (params.search?.trim()) qs.set('search', params.search.trim());
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const result = await apiFetchJson<CommunityMembersResponse>('GET', `/admin/community/members${suffix}`);
  if (!result.ok) {
    throw new Error(result.error || 'Не удалось загрузить участников');
  }
  return result.data;
}

export async function approveCommunityMembership(memberId: string): Promise<void> {
  const result = await apiFetchJson<{ ok: boolean }>(
    'POST',
    `/admin/community/members/${encodeURIComponent(memberId)}/approve-membership`,
  );
  if (!result.ok) throw new Error(result.error || 'Не удалось одобрить участника');
}

export async function approveCommunityPosition(memberId: string): Promise<void> {
  const result = await apiFetchJson<{ ok: boolean }>(
    'POST',
    `/admin/community/members/${encodeURIComponent(memberId)}/approve-position`,
  );
  if (!result.ok) throw new Error(result.error || 'Не удалось подтвердить данные о должности');
}

export async function approveCommunityGrading(memberId: string): Promise<void> {
  const result = await apiFetchJson<{ ok: boolean }>(
    'POST',
    `/admin/community/members/${encodeURIComponent(memberId)}/approve-grading`,
  );
  if (!result.ok) throw new Error(result.error || 'Не удалось подтвердить грейдинг');
}

export async function fetchRemoteMarketProfile(): Promise<MarketProfileState | null> {
  const result = await apiFetchJson<{ data: MarketProfileState | null }>(
    'GET',
    '/private-circle/community/market-profile',
  );
  if (!result.ok || !result.data.data) return null;
  return result.data.data as MarketProfileState;
}

export async function syncMarketProfileToServer(profileState: MarketProfileState): Promise<void> {
  await apiFetchJson('PUT', '/private-circle/community/market-profile', {
    body: { profileState },
  });
}
